import script from "./RelationList.vue?vue&type=script&setup=true&lang=js"
export * from "./RelationList.vue?vue&type=script&setup=true&lang=js"

import "./RelationList.vue?vue&type=style&index=0&id=3e59e236&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e59e236"]])

export default __exports__